import { trueFitConfig } from '../config';
import retrieveOrFetchToken from './retrieve-or-fetch-token';

export default async function fetchWithTokenManagement(
    locale: string,
    endpoint: string,
    options: RequestInit = {}
): Promise<any> {
    const token = await retrieveOrFetchToken(locale);
    const response = await fetch(
        `${trueFitConfig.getAPIBaseURL(locale)}${endpoint}`,
        {
            ...options,
            headers: {
                ...options.headers,
                'X-TF-UserToken': token,
                'Content-Type': 'application/json',
            },
            credentials: 'include',
        }
    );

    const newToken = response.headers.get('x-tf-usertoken');
    if (newToken && newToken !== token) {
        localStorage.setItem('trueFitToken', newToken);
    }

    if (!response.ok) {
        throw new Error(
            `API call to ${endpoint} failed: ${response.statusText}`
        );
    }

    return response.json();
}
